/*
*  Site content. Copy is word-for-word from the original Wix site (www.salgados.co.za) - check with the client before rewording
*/

export const SITE_NAME = "Salgados";
export const SITE_URL = "https://www.salgados.co.za";
//Wix's description said "familt business" - typo fixed
export const DEFAULT_DESCRIPTION = "Salgados Snacks is family business that has been crafting quality snacks with care since 2002. Discover delicious low calorie snacks including popcorn, candy floss, and crackers that anyone can enjoy.";

export const ROUTES = {
  HOME: "/",
  PRODUCTS: "/products",
  ABOUT: "/about-us",
  CONTACT: "/contact-us",
};

//Full-screen menu, in the same 2x2 order as on Wix (Home, Products / About Us, Contact Us)
export const NAV_LINKS = [
  { label: "Home", path: ROUTES.HOME, icon: "/images/icons/menu-home.svg" },
  { label: "Products", path: ROUTES.PRODUCTS, icon: "/images/icons/menu-products.svg" },
  { label: "About Us", path: ROUTES.ABOUT, icon: "/images/icons/menu-about.svg" },
  { label: "Contact Us", path: ROUTES.CONTACT, icon: "/images/icons/menu-contact.svg" },
];

export const CONTACT_DETAILS = {
  PHONE: { label: "+(27) 11 397 4685", link: "tel:+27113974685" },
  EMAIL: "info@salgados.co.za",
  ADDRESS: "226 Brakpan Road, Boksburg East, Johannesburg, Gauteng, South Africa",
  INSTAGRAM_LINK: "https://www.instagram.com/salgadosqualityfoods/",
  //The Facebook icons on Wix weren't linked to anything - this is the Salgado's Quality Foods page found on Facebook. Confirm with the client
  FACEBOOK_LINK: "https://www.facebook.com/salgadosfoods/",
};

export const CREDIT = { label: "Tap-X", link: "https://tap-x.com/" };

//"Family. Quality. Care." - the first paragraph is also used on the home page
const STORY = [
  "At Salgado’s Quality Foods, family has always been at the heart of everything we do. Established in 2002 as a proudly family-owned business, the company entered an exciting new chapter in 2025 when it was acquired by another family business, Almans Dried Fruit and Nuts — ensuring that the same values of care, quality, and commitment continue to drive the brand forward today.",
  "Over the years, Salgado’s Quality Foods has become a trusted name in South Africa’s snack industry, offering a delicious range of products enjoyed by families across the country. Our growing product range includes air-popped popcorn in both savoury and sweet varieties, fluffy candy floss, crunchy Snax Sticks, and classic Pyramid Crackers — all made with quality and flavour in mind.",
  "We are proud to operate at the highest standards of food safety and quality assurance, holding top-level HACCP and ISO certifications. Excellence is embedded into every part of our process, from production to distribution.",
  "With a dedicated sales team servicing every province in South Africa, our mission is simple: to deliver delicious, high-quality snacks to every corner of the country. Whether on supermarket shelves, at local stores, or at your favourite snack counter, Salgado’s Quality Foods is committed to bringing joy, flavour, and trusted quality to South Africans everywhere",
];

export const HOME = {
  TITLE: "Salgados Quality Food | Salgados Snacks | 226 Brakpan Road, Boksburg East, Boksburg, South Africa",
  HERO_GREEN: "Salgados Quality Food.",
  HERO_BROWN: "Snacks crafted with care.",
  INTRO: STORY[0],
  DISCOVER_PHOTOS: [
    { src: "/images/home/in-store-1.webp", alt: "Salgado's snacks on a shelf in store" },
    { src: "/images/home/in-store-2.webp", alt: "A stand of Salgado's snacks in store" },
  ],
};

//Scrolling strip under the home page banner. "range" links to that tab on the Products page, where there is one
export const TICKER = [
  { label: "Air Popped Popcorn", range: "air-popped-popcorn" },
  { label: "Snax Stix", range: "snax-stix" },
  { label: "Date Syrup" },
  { label: "Zero Calorie Noodles", range: "noodles" },
  { label: "Imported Sweets" },
  { label: "Candy Floss", range: "cotton-candy" },
  { label: "Pyramid Crackers", range: "pyramid-crackers" },
  { label: "Popcorn Kernels", range: "popcorn-kernels" },
  { label: "Kettle Popcorn" },
];

export const ABOUT = {
  TITLE: "OUR STORY",
  SUBTITLE: "A family-run business built on passion for quality food and a drive to bring great snacks to every South African shelf.",
  STORY,
  STATS: [
    { value: "2002", label: "YEAR FOUNDED" },
    { value: "6+", label: "RETAIL PARTNERS" },
    { value: "20+", label: "YEARS OF QUALITY" },
    { value: "100%", label: "FAMILY OWNED" },
  ],
};

const product = (slug, name, type) => ({ slug, name, type, image: `/images/products/${slug}.webp` });

//Tabs on the Products page (slug = the #hash in the URL, e.g. /products#pyramid-crackers)
export const PRODUCT_RANGES = [
  {
    slug: "snax-stix",
    label: "Snax Stix",
    products: [
      product("snax-stix-sea-salt-black-pepper", "Sea Salt & Black Pepper", "SNAX STIX"),
      product("snax-stix-jalapeno-cheese", "Jalapeno & Cheese", "SNAX STIX"),
      product("snax-stix-spicy-bbq", "Spicy BBQ", "SNAX STIX"),
    ],
  },
  {
    slug: "pyramid-crackers",
    label: "Pyramid Crackers",
    products: [
      product("pyramid-crackers-jalapeno-cheese", "Jalapeno & Cheese", "PYRAMID CRACKERS"),
      product("pyramid-crackers-honey-mustard", "Honey & Mustard", "PYRAMID CRACKERS"),
      product("pyramid-crackers-sour-cream-chives", "Sour Cream & Chives", "PYRAMID CRACKERS"),
      product("pyramid-crackers-salt-vinegar", "Salt & Vinegar", "PYRAMID CRACKERS"),
    ],
  },
  {
    slug: "air-popped-popcorn",
    label: "Air-Popped Popcorn",
    products: [
      product("popcorn-caramel", "Caramel", "AIR-POPPED POPCORN"),
      product("popcorn-creamy-butter-herb", "Creamy Butter & Herb", "AIR-POPPED POPCORN"),
      product("popcorn-salt-vinegar", "Salt & Vinegar", "AIR-POPPED POPCORN"),
      product("popcorn-fruit-chutney", "Fruit Chutney", "AIR-POPPED POPCORN"),
      product("popcorn-rainbow", "Rainbow", "AIR-POPPED POPCORN"),
    ],
  },
  {
    slug: "noodles",
    label: "Noodles",
    products: [
      product("noodles-fettuccine", "Fettuccine", "NO CALORIE NOODLES"),
      product("noodles-angel-hair", "Angel Hair", "NO CALORIE NOODLES"),
      product("noodles-rice-pearls", "Rice Pearls", "NO CALORIE NOODLES"),
    ],
  },
  {
    slug: "popcorn-kernels",
    label: "Popcorn Kernels",
    products: [
      product("popcorn-kernels", "Salgado's", "POPCORN KERNELS"),
    ],
  },
  {
    slug: "cotton-candy",
    label: "Cotton Candy",
    products: [
      product("candy-floss", "Salgado's", "CANDY FLOSS"),
    ],
  },
];

export const PRODUCTS = {
  TITLE: "Our Products",
  SUBTITLE: "Bold flavours, quality ingredients. Snacks made for every occasion — from spicy to sweet.",
};

export const CONTACT = {
  TITLE: "CONTACT US",
  SUBTITLE: "Feel free to reach out!",
  HOURS: ["7-5pm Monday to Thursday.", "7-3pm Friday."],
  TRADE: "Interested in stocking Salgado's products? We have national representation and distribution. Send us a message using the contact form and our team will get back to you.",
  FORM_TITLE: "Contact us",
};
